import React from 'react';
import ReactDOM from 'react-dom';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import { routes } from 'routes';
import { MainContainer } from '@monorepo/shared/src/components/layout';
import App from './App';
import ErrorPage from '@monorepo/shared/src/components/common/ErrorPage';
import reportWebVitals from './reportWebVitals';
import './index.css';
import '../../../node_modules/plyr/dist/plyr.css';

const registerPageView = (path: string): void => {
  try {
    const dataLayer = (window as any).dataLayer || [];
    dataLayer.push({ event: 'Pageview', pagePath: path });
  } catch {
    return;
  }
};

const Wrapper = ({ path, component: Component, ...props }) => {
  registerPageView(props.path);

  return (
    <MainContainer {...props} backgroundColor={props.backgroundColor}>
      <Component {...props} />
    </MainContainer>
  );
};

const formattedRoutes = routes.map(({ path, component, children, action, ...props }) => ({
  path,
  element: <Wrapper component={component} {...props} path={path} />,
  children,
  action,
}));

// using createBrowserRouter in order to use useBlocker for the RouteGuard
const router = createBrowserRouter([
  {
    path: '/',
    element: <App />,
    children: formattedRoutes,
  },
  {
    path: '/oops',
    element: <ErrorPage />,
  },
]);

ReactDOM.render(
  <React.StrictMode>
    <RouterProvider router={router} />
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
